
      /**
       * Per-card leaderboard sliver. Each card with data-game gets its
       * top-3 fetched in parallel; failures (e.g. no D1 column for a
       * game that's pre-migration) leave the card unchanged.
       */
      const cards = document.querySelectorAll("[data-game]");
      const escape = (s) => String(s).replace(/[&<>"']/g, (c) =>
        ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
      cards.forEach(async (card) => {
        const game = card.getAttribute("data-game");
        const list = card.querySelector(".card-lb");
        if (!list) return;
        try {
          const res = await fetch(`/api/leaderboard?game=${encodeURIComponent(game)}&limit=3`);
          if (!res.ok) return;
          const rows = await res.json();
          if (!Array.isArray(rows) || rows.length === 0) return;
          list.innerHTML = rows.map((r) =>
            `<li><span>#${r.rank}</span><span class="h">${escape(r.handle)}</span><span class="s">${r.score.toLocaleString()}</span></li>`
          ).join("");
        } catch { /* swallow */ }
      });
    